module.exports = __webpack_public_path__ + "static/media/ei12.49266797.png";